import { graphQlClient } from '@config/graphqlClient';
import WeatherGraphQL from '@graphql/weather.queries';
import { WeatherDay, getProjectWeatherRequest } from '@models/weather.model';

export const weatherService = {
  async getProjectWeather(projectId: string, from: string, to: string): Promise<WeatherDay[]> {
    const data: getProjectWeatherRequest = await graphQlClient.request(WeatherGraphQL.queries.getProjectWeather, {
      projectId,
      from,
      to,
    });
    return data.getProjectWeather || [];
  },
};

export default weatherService;
